export var SET_CONFIRM_MODAL = '@confirm-modal/OPEN_CONFIRM_MODAL';
export var setConfirmModalAction = function (payload) { return ({
    type: SET_CONFIRM_MODAL,
    payload: payload,
}); };
export var CONFIRM_START_ACTION_SAGA = '@confirm-modal/CONFIRM_START_ACTION_SAGA';
export var confirmModalStartActionSaga = function (payload) { return ({
    type: CONFIRM_START_ACTION_SAGA,
    payload: payload,
}); };
export var CLOSE_CONFIRM_MODAL = '@confirm-modal/CLOSE_CONFIRM_MODAL';
export var closeConfirmModalAction = function () { return ({
    type: CLOSE_CONFIRM_MODAL,
}); };
export var CONFIRM_MODAL_LOADING_START = '@confirm-modal/CONFIRM_MODAL_LOADING_START';
export var confirmModalLoadingStartAction = function () { return ({
    type: CONFIRM_MODAL_LOADING_START,
}); };
export var CONFIRM_MODAL_LOADING_STOP = '@confirm-modal/CONFIRM_MODAL_LOADING_STOP';
export var confirmModalLoadingStopAction = function () { return ({
    type: CONFIRM_MODAL_LOADING_STOP,
}); };
